import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Page from '../../components/Page';
import { VerticalSpace } from '../../components/Space';

import { actions } from '../../services/dashboard';

import styled from './DashboardStyles';

const _DataClock = ({ classes, title, data }) => (
  <Paper className={classes.container}>
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant="h6">{title}</Typography>
          </TableCell>
          <TableCell align="right">Count</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            <TableCell component="th" scope="row">
              {item.title}
            </TableCell>
            <TableCell align="right">{item.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

const DataBlock = styled(_DataClock);

class Dashboard extends React.Component {
  componentDidMount() {
    this.props.actions.load();
  }

  render() {
    const { classes, loading, error, data } = this.props;
    return (
      <Page title="Dashboard" loading={loading}>
        <Typography align="center" color="error" variant="subtitle1">
          {error}
        </Typography>

        <DataBlock
          title="Users"
          data={[
            { title: 'Online', value: data.onlineUsers },
            { title: 'Total', value: data.totalUsers },
            { title: 'Active', value: data.activeUsers },
            { title: 'Deleted', value: data.deletedUsers },
            { title: 'Blocked', value: data.blockedUsers },
            { title: 'Male', value: data.maleUsers },
            { title: 'Female', value: data.femaleUsers }
          ]}
        />
        <VerticalSpace size={20} />
        <DataBlock
          title="Photos"
          data={[
            { title: 'Total', value: data.totalPhotos },
            { title: 'Active', value: data.activePhotos },
            { title: 'Deleted', value: data.deletedPhotos },
            { title: 'Explicit', value: data.explicitPhotos }
          ]}
        />
        <VerticalSpace size={20} />
        <DataBlock
          title="Swipes"
          data={[{ title: 'Total', value: data.totalSwipes }]}
        />
        <VerticalSpace size={20} />
        <DataBlock
          title="Matches & Messages"
          data={[
            { title: 'Total', value: data.totalMatches },
            { title: 'Active', value: data.activeMatches },
            { title: 'Deleted', value: data.deletedMatches },
            { title: 'Total Messages', value: data.totalMessages }
          ]}
        />
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.dashboard.loading,
    error: state.dashboard.error,
    data: state.dashboard.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: payload => dispatch(actions.load())
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(Dashboard))
);
